import { useDispatch } from 'react-redux';
import { trackEvent } from '../../../store/UserActivity/actions';

export const useTrackEvent = () => {
  const dispatch = useDispatch();

  return (event_category, event_type, rest) =>
    dispatch(trackEvent(event_category, event_type, rest));
};
